import logoUrl from '@/assets/misc/img_taxfyle-symbol.svg'

export interface WorkspaceBranding {
  corporateMode: boolean
  logos: WorkspaceLogos
  colors: WorkspaceColorScheme
}

/**
 * Logos configuration
 */
export interface WorkspaceLogos {
  /**
   * Logo used for primary things such as headers, splash screens
   */
  primary: string
  /**
   * Same as primary, but to be used on backgrounds of varying (darker) colors.
   */
  primaryWhite: string
  /**
   * Square icon.
   */
  icon: string
  /**
   * Icon, white variant.
   */
  iconWhite: string
  /**
   * System robot avatar.
   */
  systemRobotAvatar: string
}

/**
 * Color scheme.
 */
export interface WorkspaceColorScheme {
  primary: string
  primaryDark: string | null
}

export const WorkspaceBranding = {
  /**
   * Default branding.
   */
  default: {
    colors: {
      primary: '#0088ff',
    },
    corporateMode: false,
    logos: {
      primary:
        'https://storage.googleapis.com/worklayer-assets/default-workspace-branding/logo-colorful.svg',
      primaryWhite:
        'https://storage.googleapis.com/worklayer-assets/default-workspace-branding/logo-white.svg',
      iconWhite:
        'https://storage.googleapis.com/worklayer-assets/default-workspace-branding/icon-white.svg',
      icon: logoUrl,
      systemRobotAvatar: logoUrl,
    },
  } as WorkspaceBranding,
}
